import React from 'react';
import { Navigate } from 'react-router-dom';
import { pr, r } from './helpers';
import {
  MerchantHomePage,
  MerchantDashboardPage,
  MerchantReportsPage,
  MerchantSettlementsPage,
  NewOrderPage,
  BulkUploadPage,
  LabelPage,
  BatchLabelsPage,
  MerchantMapTrackingPage,
  NotificationsPage,
  MerchantProfilePage,
} from '../lazyPages';

const MERCHANT = ['merchant'];

/**
 * Merchant routes by path (legacy on company subdomain / apex).
 * Phase 3: pages move to pages/merchant/ — paths unchanged.
 */
export function MerchantPathRoutes() {
  return (
    <>
      {pr('/merchant/orders/bulk', BulkUploadPage, MERCHANT)}
      {pr('/merchant/orders/new', NewOrderPage, MERCHANT)}
      {pr('/merchant/orders/:orderId/label', LabelPage, MERCHANT)}
      {/* Detail opens in-sheet on list page (deep links + notifications) */}
      {pr('/merchant/orders/:orderId', MerchantDashboardPage, MERCHANT)}
      {pr('/merchant/orders', MerchantDashboardPage, MERCHANT)}
      {pr('/merchant/labels/batch', BatchLabelsPage, MERCHANT)}
      {pr('/merchant/reports', MerchantReportsPage, MERCHANT)}
      {pr('/merchant/settlements', MerchantSettlementsPage, MERCHANT)}
      {pr('/merchant', MerchantHomePage, MERCHANT)}
      {pr('/merchant/track/:orderId', MerchantMapTrackingPage, MERCHANT)}
      {pr('/merchant/notifications', NotificationsPage, MERCHANT)}
      {pr('/merchant/profile', MerchantProfilePage, MERCHANT)}
    </>
  );
}

/** Merchant subdomain (merchant-{slug}.domain) — authenticated. */
export function MerchantSubdomainAuthRoutes() {
  return (
    <>
      {pr('/', MerchantHomePage, MERCHANT)}
      {r('/login', <Navigate to="/" replace />)}
      {r('/m/login', <Navigate to="/login" replace />)}
      {r('/merchant', <Navigate to="/" replace />)}
      {pr('/merchant/orders/bulk', BulkUploadPage, MERCHANT)}
      {pr('/merchant/orders/new', NewOrderPage, MERCHANT)}
      {pr('/merchant/orders/:orderId/label', LabelPage, MERCHANT)}
      {pr('/merchant/orders/:orderId', MerchantDashboardPage, MERCHANT)}
      {pr('/merchant/orders', MerchantDashboardPage, MERCHANT)}
      {pr('/merchant/reports', MerchantReportsPage, MERCHANT)}
      {pr('/merchant/settlements', MerchantSettlementsPage, MERCHANT)}
      {pr('/merchant/labels/batch', BatchLabelsPage, MERCHANT)}
      {pr('/merchant/track/:orderId', MerchantMapTrackingPage, MERCHANT)}
      {pr('/merchant/notifications', NotificationsPage, MERCHANT)}
      {pr('/merchant/profile', MerchantProfilePage, MERCHANT)}
    </>
  );
}